import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import Title from '../../Title';
import Button from '../../Button';

interface Props {
  title: string;
  onBack?: () => void;
  primaryAction?: React.ReactNode;
}

export default function PageHeader({ title, onBack, primaryAction }: Props) {
  return (
    <div className="admin-page-header">
      <div className="admin-page-header__title-row">
        {onBack && (
          <Button
            variant="tertiary"
            size="sm"
            iconOnly
            className="admin-page-header__back"
            onClick={onBack}
            aria-label="Go back"
          >
            <ArrowLeftIcon
              className="admin-page-header__back-icon"
              aria-hidden="true"
            />
          </Button>
        )}
        <Title>{title}</Title>
        {primaryAction && (
          <div className="admin-page-header__action">{primaryAction}</div>
        )}
      </div>
    </div>
  );
}
